<div class="page-container">
    <div fxLayout="column">
        <app-page-header [section]="'Atoku'" [title]="'Users'"
            [description]="'Manage your Atoku users and access states here.'"></app-page-header>

        <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">
            <div class="mat-elevation-z3 radius-10 crud-table-shell" fxLayout="column">
                <app-crud-table
                    [modelType]="crudUserModel"
                    [tableData]="tableData"
                    [title]="'Users'"
                    [subTitle]="'Manage Atoku users, subscriptions, and access actions'"
                    [additionalActions]="additionalActions">
                </app-crud-table>
            </div>
        </div>
    </div>
</div>
